




























































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
@Component({
    components: {}
})
export default class suppliermanage extends pagelist {
    get prox() {
        return new proxy.ChannelBalanceLogServiceProxy();
    }
    input: proxy.ChannelBalanceLogPageInputDto = new proxy.ChannelBalanceLogPageInputDto();
    sub_id = 0;
    createOrEditShow = false;
    createrange = [];
    BalanceTypes = []
    columns = [
        {
            type: 'selection',
            width: 60,
            align: 'center'
        },

        {
            title: '流水号',
            key: 'serialNumber',
            width: 240
        },
        {
            title: '通道',
            key: 'channelName',
        },

        {
            title: '变动金额',
            slot: 'money'
        },
        {
            title: '变动前',
            slot: 'balance'
        },
        {
            title: '变动后',
            slot: 'afterBalance'
        },
        {
            title: '关联单号',
            key: 'tid',
            width: 240
        },
        {
            title: '类型',
            key: 'balanceTypeName'
        },
        {
            title: '创建时间',
            key: 'creationTime',
            width: 180
        }
    ];
    fetchDataList(
        request: PagedFilterAndSortedRequest,
        pageNumber: number,
        finishedCallback: Function
    ): void {
        this.input.skipCount = request.skipCount;
        this.input.maxResultCount = request.maxResultCount;
        this.input.sorting = request.sorting;
        this.input.createStartTime = this.createrange[0];
        this.input.createEndTime = this.createrange[1];
        this.prox.queryModelList(this.input).then(x => {
            this.dataList = x.items;
            this.showPaging(x);
        });
    }
    exportrecord() {
        var ids = this.selectedDataItems.map((x) => {
            return x.id;
        });
        this.input.ids = ids;
        // this.prox.export(this.input).then((x) => {
        //   location.href =
        //     AppConsts.remoteServiceBaseUrl +
        //     '/File/DownloadTempFile?FileToken=' +
        //     x.fileToken +
        //     '&fileName=' +
        //     x.fileName +
        //     '&fileType=' +
        //     x.fileType;
        // });
    }
    getpage() {
        this.OnInit();
    }
    async created() {
        new proxy.CommonServiceProxy().getEnumKeyValue('ChannelBalanceLogTypeEnum').then(x => {
            this.BalanceTypes = x;
        })
        this.getpage();
    }

}
